import axios from "axios";
import { correctRoute, ip } from "./config";

export async function correctAnswer() {
  return axios.get(ip + correctRoute).then((res) => res.data);
}
